var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "download-list" },
    _vm._l(_vm.listEntries, function(entry) {
      return _c("div", { staticClass: "download-list__item" }, [
        entry.url && entry.url.value !== null
          ? _c(
              "a",
              {
                staticClass: "download-list__link",
                attrs: { href: entry.url.value }
              },
              [
                _c("div", { staticClass: "download-list__bg" }, [
                  _c(
                    "svg",
                    {
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "41",
                        height: "41",
                        viewBox: "0 0 41 41"
                      }
                    },
                    [
                      _c("g", { attrs: { fill: "#FFF" } }, [
                        _c("path", {
                          attrs: {
                            d:
                              "M38.95,24.6 C40.0013135,24.6 40.8677897,25.3913824 40.9862082,26.4109267 L41,26.65 L41,34.85 C41,38.1252458 38.4397141,40.8025048 35.2113592,40.98956 L34.85,41 L6.15,41 C2.87475419,41 0.197495197,38.4397141 0.0104400215,35.2113592 L0,34.85 L0,26.65 C0,25.5178163 0.917816263,24.6 2.05,24.6 C3.10131347,24.6 3.96778968,25.3913824 4.08620815,26.4109267 L4.1,26.65 L4.1,34.85 C4.1,35.9013135 4.89138239,36.7677897 5.91092669,36.8862082 L6.15,36.9 L34.85,36.9 C35.9013135,36.9 36.7677897,36.1086176 36.8862082,35.0890733 L36.9,34.85 L36.9,26.65 C36.9,25.5178163 37.8178163,24.6 38.95,24.6 Z"
                          }
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            d:
                              "M8.8004311,14.9504311 C9.53942322,14.211439 10.7022469,14.1545934 11.5064439,14.7798945 L11.6995689,14.9504311 L20.5,23.74925 L29.3004311,14.9504311 C30.0394232,14.211439 31.2022469,14.1545934 32.0064439,14.7798945 L32.1995689,14.9504311 C32.938561,15.6894232 32.9954066,16.8522469 32.3701055,17.6564439 L32.1995689,17.8495689 L21.9495689,28.0995689 C21.2105768,28.838561 20.0477531,28.8954066 19.2435561,28.2701055 L19.0504311,28.0995689 L8.8004311,17.8495689 C7.9998563,17.0489941 7.9998563,15.7510059 8.8004311,14.9504311 Z"
                          }
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            d:
                              "M20.5,0 C21.5513135,0 22.4177897,0.79138239 22.5362082,1.81092669 L22.55,2.05 L22.55,26.65 C22.55,27.7821837 21.6321837,28.7 20.5,28.7 C19.4486865,28.7 18.5822103,27.9086176 18.4637918,26.8890733 L18.45,26.65 L18.45,2.05 C18.45,0.917816263 19.3678163,0 20.5,0 Z"
                          }
                        })
                      ])
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "download-list__txt" }, [
                  _vm._v(_vm._s(entry.text))
                ])
              ]
            )
          : _vm._e()
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }